var map = {
	"./GustavAttackPortal.json": [
		576,
		26
	],
	"./GustavDustParticleBackLeft.json": [
		577,
		27
	],
	"./GustavDustParticleBackRight.json": [
		578,
		28
	],
	"./GustavDustParticleFrontLeft.json": [
		579,
		29
	],
	"./GustavDustParticleFrontRight.json": [
		580,
		30
	],
	"./GustavEmberParticle.json": [
		581,
		31
	],
	"./GustavFinalAttackPortal.json": [
		582,
		32
	],
	"./GustavFinalDustParticleBackLeft.json": [
		583,
		33
	],
	"./GustavFinalDustParticleBackRight.json": [
		584,
		34
	],
	"./GustavFinalDustParticleFrontLeft.json": [
		585,
		35
	],
	"./GustavFinalDustParticleFrontRight.json": [
		586,
		36
	],
	"./GustavFinalGroundHitParticle.json": [
		587,
		37
	],
	"./GustavFinalSwordParticle.json": [
		588,
		38
	],
	"./GustavGroundHitParticle.json": [
		589,
		39
	],
	"./GustavSwordParticle.json": [
		590,
		40
	],
	"./smoke.json": [
		591,
		41
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1082;
module.exports = webpackAsyncContext;